function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "external_link_square_svg__cls-1",
  d: "M16.29 13.24a3.06 3.06 0 01-3.05 3.05H3.05A3.06 3.06 0 010 13.24V3.06A3.06 3.06 0 013.05.01h10.18a3.06 3.06 0 013.05 3.05v10.18zM13.58 3.4a.68.68 0 00-.68-.68H7.81a.69.69 0 00-.63.41.67.67 0 00.15.74L8.86 5.4 3.2 11.06a.67.67 0 000 1l1.08 1.08a.67.67 0 001 0l5.66-5.66 1.53 1.53a.63.63 0 00.48.2.79.79 0 00.26-.05.69.69 0 00.41-.63V3.44z"
});

var SvgExternalLinkSquare = function SvgExternalLinkSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 16.29 16.29"
  }, props), _ref);
};

export default SvgExternalLinkSquare;